import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';

import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/styles';

import DatePickerField from '../fields/DatePickerField';
import TextField from '../fields/TextField';
import TimePickerField from '../fields/TimePickerField';
import SelectField from "../fields/SelectField";
import MenuItem from "@material-ui/core/MenuItem";
import CheckboxField from "../fields/CheckboxField";

const RideForm = ({ classes, error, handleSubmit, pristine, stops, submitting, disruptionEnded }) => (
  <form onSubmit={handleSubmit}>
    {error && <Typography variant="subtitle1">{error}</Typography>}

    <Field
      name="distance-depot-start"
      component={TextField}
      label="Kilometerstand start rit (1/4)"
      fullWidth
      id="ride_form_distance_depot_start"
    />

    <Field
      name="datetime-depot-start-date"
      component={DatePickerField}
      label="Dag"
      datePickerProps={{
        format: 'dd-MM-yyyy',
      }}
      className={classes.datePickerField}
    />

    <Field
      name="datetime-depot-start-time"
      component={TimePickerField}
      label="Tijdstip"
      className={classes.timePickerField}
    />

    <Field
      id="disruption-ended-shuttle-start"
      name="disruption-ended-shuttle-start"
      component={CheckboxField}
      label="Stremming afgemeld"
      color="primary"
      className={classes.checkboxField}
    />

    <Field
      name="distance-shuttle-start"
      component={TextField}
      label="Kilometerstand start pendelen (2/4)"
      fullWidth
      id="ride_form_distance_shuttle_start"
    />

    <Field
      name="location-shuttle-start"
      id="ride_form_location_shuttle_start"
      component={SelectField}
      label="Locatie start pendelen (2/4)"
      style={classes.selectField}
      disabled={stops.length === 0 || disruptionEnded === true}
    >
      {stops.map((stop) => (
        <MenuItem key={stop.id} value={stop.id}>{stop.name}</MenuItem>
      ))}
    </Field>

    <Field
      name="datetime-shuttle-start-date"
      component={DatePickerField}
      label="Dag"
      datePickerProps={{
        format: 'dd-MM-yyyy',
      }}
      className={classes.datePickerField}
    />

    <Field
      name="datetime-shuttle-start-time"
      component={TimePickerField}
      label="Tijdstip"
      className={classes.timePickerField}
    />

    <Field
      name="distance-shuttle-end"
      component={TextField}
      label="Kilometerstand eind pendelen (3/4)"
      fullWidth
      id="ride_form_distance_shuttle_end"
    />

    <Field
      name="location-shuttle-end"
      id="ride_form_location_shuttle_end"
      component={SelectField}
      label="Locatie eind pendelen (3/4)"
      style={classes.selectField}
      disabled={stops.length === 0 || disruptionEnded}
    >
      {stops.map((stop) => (
        <MenuItem key={stop.id} value={stop.id}>{stop.name}</MenuItem>
      ))}
    </Field>

    <Field
      name="datetime-shuttle-end-date"
      component={DatePickerField}
      label="Dag"
      datePickerProps={{
        format: 'dd-MM-yyyy',
      }}
      className={classes.datePickerField}
    />

    <Field
      name="datetime-shuttle-end-time"
      component={TimePickerField}
      label="Tijdstip"
      className={classes.timePickerField}
    />

    <Field
      name="distance-depot-end"
      component={TextField}
      label="Kilometerstand eind rit (4/4)"
      fullWidth
      id="ride_form_distance_depot_end"
    />

    <Field
      name="datetime-depot-end-date"
      component={DatePickerField}
      label="Dag"
      datePickerProps={{
        format: 'dd-MM-yyyy',
      }}
      className={classes.datePickerField}
    />

    <Field
      name="datetime-depot-end-time"
      component={TimePickerField}
      label="Tijdstip"
      className={classes.timePickerField}
    />

    <CardActions className={classes.cardActions}>
      <Button
        disabled={pristine || submitting}
        variant="contained"
        color="primary"
        type="submit"
      >Bewerk rit</Button>
    </CardActions>
  </form>
);

RideForm.propTypes = {
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  stops: PropTypes.arrayOf(PropTypes.shape({
    'id': PropTypes.string.isRequired,
    'name': PropTypes.string.isRequired,
  })).isRequired,
  submitting: PropTypes.bool.isRequired,
};

RideForm.defaultProps = {
  error: undefined,
};

const selector = formValueSelector('RideForm')

const mapStateToProps = (state) => ({
  disruptionEnded: selector(state, 'disruption-ended-shuttle-start')
});

export default connect(mapStateToProps, {})(reduxForm({
  form: 'RideForm',
  validate: (values) => {
    const errors = {};
    const distanceFields = [
      'distance-depot-start',
      'distance-shuttle-start',
      'distance-shuttle-end',
      'distance-depot-end',
    ];

    distanceFields.forEach((field) => {
      if (isNaN(values[field]))
        errors[field] = 'Dit veld moet een geldige numerieke waarde bevatten';
    });

    return errors;
  },
})(withStyles({
  cardActions: {
    marginTop: 20,
    width: '100%',
  },
  datePickerField: {
    float: 'left',
    marginRight: 20,
  },
  timePickerField: {
    float: 'left',
    width: 50,
  },
  selectField: {
    width: '100%',
    marginBottom: 20,
  },
  checkboxField: {
    float: 'left',
    marginVertical: 0,
    paddingVertical: 0,
  },
})(RideForm)));
